import {
  OnSiteMovementType,
  OnSiteMovementStatus
} from '../on-site-movement/on-site-movement.models';
import { DateTime } from 'luxon';

export class SeaState {
  id: number;
  tag: string;
  name: string;
}

export class DeepWellTieIn {
  id: number;
  tag: string;
  name: string;
}

export class SeaWaterSuction {
  id: number;
  tag: string;
  name: string;
}

export class MetadataCollection {
  seaStates: SeaState[] = [];
  deepWellTieIns: DeepWellTieIn[] = [];
  seaWaterSuctionOptions: SeaWaterSuction[] = [];
  onSiteMovementTypes: OnSiteMovementType[] = [];
  onSiteMovementStatuses: OnSiteMovementStatus[] = [];
}

export class OperationMetadataRequest {
  stageIds: number[] = [];
  vesselId: number;
  dailyLogDate: DateTime;
}



// WEBPACK FOOTER //
// ./src/models/metadata/metadata.models.ts